import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconReceiptLongOutline = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 80 81"
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M20 72.167c-2.33 0-4.3-.807-5.914-2.42-1.613-1.614-2.42-3.58-2.42-5.899V55.5h10V9.474l4.616 3.975 4.68-3.975 4.679 3.975 4.68-3.975L45 13.45l4.679-3.975 4.68 3.975 4.68-3.975 4.678 3.975 4.616-3.975v54.36c0 2.328-.806 4.3-2.42 5.913-1.613 1.613-3.584 2.42-5.913 2.42H20zm40-5c.944 0 1.736-.32 2.375-.959s.958-1.43.958-2.375V17.167H26.667V55.5h30v8.333c0 .945.319 1.736.958 2.375.639.64 1.43.959 2.375.959zm-29.36-37.5v-5h18.91v5H30.64zm0 10v-5h18.91v5H30.64zm25.834-9.552a2.844 2.844 0 01-2.087-.862 2.844 2.844 0 01-.861-2.086c0-.817.287-1.512.861-2.087a2.844 2.844 0 012.087-.862c.816 0 1.512.288 2.087.862.575.575.862 1.27.862 2.087 0 .816-.287 1.511-.862 2.086a2.844 2.844 0 01-2.087.862zm0 10a2.844 2.844 0 01-2.087-.862 2.844 2.844 0 01-.861-2.086c0-.817.287-1.512.861-2.087a2.844 2.844 0 012.087-.862c.816 0 1.512.287 2.087.862.575.575.862 1.27.862 2.087 0 .816-.287 1.511-.862 2.086a2.844 2.844 0 01-2.087.862zM20 67.167h31.666V60.5h-35v3.333c0 .945.32 1.736.959 2.375.639.64 1.43.959 2.375.959z"
        fill="#000"
        fillOpacity={0.1}
      />
    </Svg>
  );
};
